import React from 'react';
import KeyIcon from 'material-ui-icons/VpnKey';
import StarIcon from 'material-ui-icons/Star';

let HotelCategoryRender = props => {
    const { category } = props;
    const style = props.style ? props.style : {};
    if (!category) {
        return '';
    }
    let chipStyle = {
        height: '20px',
        lineHeight: '20px',
        textAlign: 'center',
        float: 'left',
    };
    const chipTextStyle = {
        margin: '2 auto',
        color: 'white',
        fontSize: '13px',
        display: 'inline-block',
        verticalAlign: 'middle',
        lineHeight: 'normal',
        paddingBottom: '2px',
        paddingLeft: '2px',
        paddingRight: '2px',
    };
    const colorNames = {
        '': 'grey',
        undefined: 'grey',
        'ap.tur.': '#466957',
        albergue: '#080B59',
        pension: '#868789',
        hostal: '#184C89',
        'c.rural': '#446A8C',
    };
    let stars;
    let keys;
    switch (category.type) {
    case 'star':
        stars = Array.from(Array(category.weight).keys()).map((option, ix) => (
            <StarIcon style={style} key={ix} alt='categoria' title={category.label} />
            //<img src={starIcon} align="center" />
        ));
        return <span className="stars">{stars}</span>;
    case 'key':
        keys = Array.from(Array(category.weight).keys()).map((option, ix) => (
            <KeyIcon key={ix} alt='categoria' title={category.label} />
            //<img key={ix} alt='categoria' title={category.label} src={keyIcon} align="center" />
        ));

        return <span className="keys">{keys}</span>;
    }
    let label = category.label ? category.label : '';
    chipStyle.backgroundColor = colorNames[label] ? colorNames[label] : '#868789';
    return (
        <span className="chip">
            <strong>{category.label}</strong>
        </span>
    );
};

export default HotelCategoryRender;


// WEBPACK FOOTER //
// ./src/components/Reservation/HotelCategoryRender.js